import React, { Component } from 'react';
import styles from './PageNotFound.scss';

export class PageNotFound extends Component {
  render(){
    return (
      <div className={styles.wrapper}>
        <h1 className={styles.code}>404</h1>
        <div className={styles.caption}>Страница не найдена</div>
      </div>
    );
  }
}
